import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectAccounts } from 'stash/selectors';
import { isAllowedToTrade } from './utils';
import { isStateZeroBuyFlow } from 'stash/components/investment-detail/utils';

const mapStateToProps = (state) => ({
	accounts: selectAccounts(state),
});

/**
 * This is a standalone account state check to confirm that a user is eligible
 * to make transactions. A user is only eligible to trade if any account is in
 * a `complete` state. If a user is not eligible, it will redirect to
 * /purchase-verification which renders a specific BuyBlockedMessage.
 */
export const BuyVerification = ({ accounts, viewType }) => {
	if (isAllowedToTrade(accounts) || isStateZeroBuyFlow(viewType)) return null;

	const returnUrl = window.location.pathname + window.location.search;

	return (
		<Redirect to={`/purchase-verification?returnUrl=${encodeURIComponent(returnUrl)}`} />
	);
};

BuyVerification.propTypes = {
	accounts: PropTypes.object,
	viewType: PropTypes.string,
};

export default connect(mapStateToProps, null)(BuyVerification);
